<template>
  <div v-if="!fetching">
    <FacebookCampaignHeader v-bind="{ title: facebookCampaign.name }" />
    <TabbedMenu />
    <div class="p-16">
      <Transition name="slide-right" mode="out-in">
        <RouterView />
      </Transition>
    </div>
  </div>
</template>

<script>
import { facebookCampaignComputed, facebookCampaignMethods } from '@/store/adminHelper';
import FacebookCampaignHeader from './single/Header.vue';
import TabbedMenu from './single/TabbedMenu.vue';

export default {
  name: 'Single',
  components: {
    FacebookCampaignHeader,
    TabbedMenu,
  },
  props: {
    facebookCampaignId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...facebookCampaignComputed,
  },
  created() {
    this.fetchFacebookCampaign();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...facebookCampaignMethods,
    async fetchFacebookCampaign() {
      this.fetching = true;
      try {
        await this.getFacebookCampaign({
          facebookCampaignId: this.facebookCampaignId,
          queryParams: {
            include: 'lifetimeReport,dailyReports',
          },
        });
      } catch (error) {
        //
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>
